/**
 * The base IP for a local kernel gateway
 */
export const GATEWAY_BASE_URI = 'http://127.0.0.1';

/**
 * The standard gateway URI assuming the port is unused
 */
export const DEFAULT_GATEWAY_URI = 'http://127.0.0.1:8888';
